import { CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES } from "shared/types/enums";

import { Features } from "../types/interfaces";
import { FeatureValue } from "../types/types";

export const getFeatureEntries = (features: Features) =>
    Object.entries(features) as [
        CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES,
        FeatureValue
    ][];
